import React from "react";
import { FooterLogo } from "../assets/footerLogo";
import { useNavigate } from "react-router-dom";
import { Footer } from "../components/footer";
import { navigateWithLang } from "../components/languageRouter";
import { useTranslation } from "react-i18next";

export const InfoPageWrapper = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  return (
    <div className="flex flex-col gap-[100px]">
      <div className="mx-auto w-[92%] md:w-[75%] lg:w-[60%] mt-5-res">
        <div className="justify-items-center">
          <div
            onClick={() => navigateWithLang(navigate, "/", i18n.language)}
            className="cursor-pointer"
          >
            <FooterLogo />
          </div>
        </div>

        <div className="mt-6-res">{children}</div>
      </div>
      <Footer />
    </div>
  );
};
